import axios from "axios";
import { langs }  from "../enums/langs.enum";
// const API_URL = process.env.REACT_APP_API_BACKEND;
const API_URL = (process.env.REACT_APP_API_BACKEND !== undefined) ? process.env.REACT_APP_API_BACKEND : "https://api.we.cent.beauty";
const authHeader = (crmToken) => {
  const token = localStorage.getItem("access_token");
  const lang = (localStorage.getItem("lang") && langs.includes(localStorage.getItem("lang"))) ? localStorage.getItem("lang") : langs[0]
  const headers = {lang};
  if (token) {
    headers["Authorization"] = `Bearer ${token}`
  } else {
    headers["Authorization"] = `Bearer ${crmToken}`
  }

  return headers;
};

const authHeader2 = (crmToken) => {
  const token = localStorage.getItem("access_token");
  const lang = (localStorage.getItem("lang") && langs.includes(localStorage.getItem("lang"))) ? localStorage.getItem("lang") : langs[0]
  const headers = {lang};
  if (token) {
    headers["Authorization"] = `Bearer ${token}`
  } else {
    headers["Authorization"] = `Bearer ${crmToken}`
  }
  headers["content-type"] = "multipart/form-data"

  return headers;
};

export async function axiosGet(uri) {
  return await axios({
    url: `${API_URL}/${uri}`,
    method: "GET",
    data: [],
    headers: authHeader(),
  });
}

export async function axiosServiceFormData(uri, method, data, token) {
  return axios({
    url: `${API_URL}/${uri}`,
    method,
    data,
    headers: authHeader2(token),
  });
}

export default function axiosService(uri, method, data, token) {
  return axios({
    url: `${API_URL}/${uri}`,
    method,
    data,
    headers: authHeader(token),
  });
}

